import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPowerOnTerminal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 189,
	height: 386,
	viewBox: "0 0 189 386",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: .247299,
			width: 189,
			height: 385.505,
			rx: 56,
			fill: "#CED3DA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9.55225,
			y: 9.11736,
			width: 170.578,
			height: 367.083,
			rx: 56,
			fill: "#B8BEC6"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 33.4331,
			y: 69.1607,
			width: 122.134,
			height: 161.708,
			fill: "#DDE0E5"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_2009_35074)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 21.1516,
				y: 259.525,
				width: 34.7978,
				height: 18.4224,
				rx: 8,
				fill: "#A1A8B0"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 22.1516,
				y: 260.525,
				width: 32.7978,
				height: 16.4224,
				rx: 7,
				stroke: "#6F7780",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_d_2009_35074)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 21.1516,
				y: 283.406,
				width: 34.7978,
				height: 18.4224,
				rx: 8,
				fill: "#A1A8B0"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 22.1516,
				y: 284.406,
				width: 32.7978,
				height: 16.4224,
				rx: 7,
				stroke: "#6F7780",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_d_2009_35074)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 21.1516,
				y: 307.287,
				width: 34.7978,
				height: 18.4224,
				rx: 8,
				fill: "#A1A8B0"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 22.1516,
				y: 308.287,
				width: 32.7978,
				height: 16.4224,
				rx: 7,
				stroke: "#6F7780",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter3_d_2009_35074)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 21.1516,
				y: 331.168,
				width: 34.7978,
				height: 18.4224,
				rx: 8,
				fill: "#A1A8B0"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 22.1516,
				y: 332.168,
				width: 32.7978,
				height: 16.4224,
				rx: 7,
				stroke: "#6F7780",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter4_d_2009_35074)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 60.0432,
				y: 259.525,
				width: 35.4801,
				height: 18.4224,
				rx: 8,
				fill: "#A1A8B0"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 61.0432,
				y: 260.525,
				width: 33.4801,
				height: 16.4224,
				rx: 7,
				stroke: "#6F7780",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter5_d_2009_35074)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 60.0432,
				y: 283.406,
				width: 35.4801,
				height: 18.4224,
				rx: 8,
				fill: "#A1A8B0"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 61.0432,
				y: 284.406,
				width: 33.4801,
				height: 16.4224,
				rx: 7,
				stroke: "#6F7780",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter6_d_2009_35074)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 60.0432,
				y: 307.287,
				width: 35.4801,
				height: 18.4224,
				rx: 8,
				fill: "#A1A8B0"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 61.0432,
				y: 308.287,
				width: 33.4801,
				height: 16.4224,
				rx: 7,
				stroke: "#6F7780",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter7_d_2009_35074)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 60.0432,
				y: 331.168,
				width: 35.4801,
				height: 18.4224,
				rx: 8,
				fill: "#A1A8B0"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 61.0432,
				y: 332.168,
				width: 33.4801,
				height: 16.4224,
				rx: 7,
				stroke: "#6F7780",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter8_d_2009_35074)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 99.6174,
				y: 259.525,
				width: 34.7978,
				height: 18.4224,
				rx: 8,
				fill: "#A1A8B0"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 100.617,
				y: 260.525,
				width: 32.7978,
				height: 16.4224,
				rx: 7,
				stroke: "#6F7780",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter9_d_2009_35074)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 99.6174,
				y: 283.406,
				width: 34.7978,
				height: 18.4224,
				rx: 8,
				fill: "#A1A8B0"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 100.617,
				y: 284.406,
				width: 32.7978,
				height: 16.4224,
				rx: 7,
				stroke: "#6F7780",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter10_d_2009_35074)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 99.6174,
				y: 307.287,
				width: 34.7978,
				height: 18.4224,
				rx: 8,
				fill: "#A1A8B0"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 100.617,
				y: 308.287,
				width: 32.7978,
				height: 16.4224,
				rx: 7,
				stroke: "#6F7780",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter11_d_2009_35074)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 146.014,
				y: 259.525,
				width: 30.0217,
				height: 18.4224,
				rx: 8,
				fill: "#A1A8B0"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 147.014,
				y: 260.525,
				width: 28.0217,
				height: 16.4224,
				rx: 7,
				stroke: "#6F7780",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter12_d_2009_35074)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 146.014,
				y: 283.406,
				width: 30.0217,
				height: 18.4224,
				rx: 8,
				fill: "#A1A8B0"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 147.014,
				y: 284.406,
				width: 28.0217,
				height: 16.4224,
				rx: 7,
				stroke: "#6F7780",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter13_d_2009_35074)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 146.014,
				y: 307.287,
				width: 30.0217,
				height: 34.7978,
				rx: 8,
				fill: "#C5F6DA"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 147.014,
				y: 308.287,
				width: 28.0217,
				height: 32.7978,
				rx: 7,
				stroke: "#08873F",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter14_d_2009_35074)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 99.6174,
				y: 331.168,
				width: 34.7978,
				height: 18.4224,
				rx: 8,
				fill: "#A1A8B0"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 100.617,
				y: 332.168,
				width: 32.7978,
				height: 16.4224,
				rx: 7,
				stroke: "#6F7780",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 161.025,
			cy: 324.345,
			r: 6.50541,
			stroke: "#08873F",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_2009_35074",
				x: 19.1516,
				y: 259.525,
				width: 38.7979,
				height: 22.4224,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2009_35074"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2009_35074",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_2009_35074",
				x: 19.1516,
				y: 283.406,
				width: 38.7979,
				height: 22.4224,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2009_35074"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2009_35074",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_2009_35074",
				x: 19.1516,
				y: 307.287,
				width: 38.7979,
				height: 22.4224,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2009_35074"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2009_35074",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_d_2009_35074",
				x: 19.1516,
				y: 331.168,
				width: 38.7979,
				height: 22.4224,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2009_35074"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2009_35074",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter4_d_2009_35074",
				x: 58.0432,
				y: 259.525,
				width: 39.4802,
				height: 22.4224,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2009_35074"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2009_35074",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter5_d_2009_35074",
				x: 58.0432,
				y: 283.406,
				width: 39.4802,
				height: 22.4224,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2009_35074"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2009_35074",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter6_d_2009_35074",
				x: 58.0432,
				y: 307.287,
				width: 39.4802,
				height: 22.4224,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2009_35074"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2009_35074",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter7_d_2009_35074",
				x: 58.0432,
				y: 331.168,
				width: 39.4802,
				height: 22.4224,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2009_35074"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2009_35074",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter8_d_2009_35074",
				x: 97.6174,
				y: 259.525,
				width: 38.7979,
				height: 22.4224,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2009_35074"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2009_35074",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter9_d_2009_35074",
				x: 97.6174,
				y: 283.406,
				width: 38.7979,
				height: 22.4224,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2009_35074"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2009_35074",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter10_d_2009_35074",
				x: 97.6174,
				y: 307.287,
				width: 38.7979,
				height: 22.4224,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2009_35074"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2009_35074",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter11_d_2009_35074",
				x: 144.014,
				y: 259.525,
				width: 34.0217,
				height: 22.4224,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2009_35074"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2009_35074",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter12_d_2009_35074",
				x: 144.014,
				y: 283.406,
				width: 34.0217,
				height: 22.4224,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2009_35074"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2009_35074",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter13_d_2009_35074",
				x: 144.014,
				y: 307.287,
				width: 34.0217,
				height: 38.7978,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2009_35074"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2009_35074",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter14_d_2009_35074",
				x: 97.6174,
				y: 331.168,
				width: 38.7979,
				height: 22.4224,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2009_35074"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2009_35074",
						result: "shape"
					})
				]
			})
		] })
	]
});
export default SvgPowerOnTerminal;
